(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands"] && !Shopify.designMode) return;
  try {
    
 $(document).ready(function(){
     var brand_logos = $("#client-car");
      brand_logos.owlCarousel({
        items:8,
         loop:true,      
       dots: true, 
	   autoplay: true,
	   autoplayTimeout: 3000,
          responsive:{
           0:{
             items: 1
           },
           600:{
             items:2
           },
           700:{
             items:4
           },
           
           1000:{
             items: 8
           }
         }
  			});
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
jQuery(function($){
  var drawer = document.getElementById('SnSearchDrawer');
  var sToggles = document.querySelectorAll('.sn-search-toggle');
  var sClose = document.getElementById('SnSearchClose');
  var sInput = document.getElementById('SnSearchInput');
  sToggles.forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      if (!drawer) return;
      drawer.classList.toggle('is-open');
      if (drawer.classList.contains('is-open') && sInput) { setTimeout(function(){ sInput.focus(); }, 100); }
    });
  });
  if (sClose) sClose.addEventListener('click', function(){ if (drawer) drawer.classList.remove('is-open'); });

  var mMenu = document.getElementById('SnMobileMenu');
  var mOverlay = document.getElementById('SnMenuOverlay');
  var mOpen = document.getElementById('SnMenuOpen');
  var mClose = document.getElementById('SnMenuClose');
  function openMenu(){ if(mMenu){ mMenu.classList.add('is-open'); mOverlay.classList.add('is-open'); document.body.style.overflow='hidden'; } }
  function closeMenu(){ if(mMenu){ mMenu.classList.remove('is-open'); mOverlay.classList.remove('is-open'); document.body.style.overflow=''; } }
  if (mOpen) mOpen.addEventListener('click', openMenu);
  if (mClose) mClose.addEventListener('click', closeMenu);
  if (mOverlay) mOverlay.addEventListener('click', closeMenu);

  // Accordion expand
  document.querySelectorAll('.sn-mmenu__expand').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      var li = btn.closest('.sn-mmenu__has-children');
      if (li) li.classList.toggle('is-open');
    });
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { if (drawer) drawer.classList.remove('is-open'); closeMenu(); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-deals"]) return;
  try {
    
 $(document).ready(function(){
     var homeSidedeals = $(".sidebar-deal-products");
      homeSidedeals.owlCarousel({
      items:1,
         loop:true,              
         dots: false,
         navContainer: ".home_sidebar--deal-nav",
         navText: [' <a class="prev active btn"><i class="icon-arrow-left icons"></i></a>','<a class="next btn"><i class="icon-arrow-right icons"></i></a>']
        
  			});
        });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
   $(this).html('<i class="fa fa-plus"></i>');
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
     $(this).html('<i class="fa fa-minus"></i>');
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
function process_slick_event(evt) {
var _slick = $( "#" +evt.target.id + " .home-slideshow .variable-width");
if( _slick.length )
{
switch ( evt.originalEvent.type ) {
case "shopify:section:load" : 
console.log('Load ' + _slick.attr("id"));
_slick.slick (
{
dots: true,
slidesToScroll: 1,

autoplay: _slick.data('slick').autoplay,
autoplaySpeed: _slick.data('slick').autoplaySpeed
}
);
break; 
case "shopify:section:unload" :
console.log('Unload ' + _slick.attr("id"));
_slick.slick('unslick');
break;

} 
}
}

$(document)
.on( 'shopify:section:load', process_slick_event )
.on( 'shopify:section:unload', process_slick_event )
;


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
if (jQuery.cookie('headerTop') == 'closed') {
jQuery('.header-top').fadeOut();
}

jQuery('.header-top a.close').bind('click',function(){
jQuery('.header-top').fadeOut();
jQuery.cookie('headerTop', 'closed', {expires:-1, path:'/'});
});  

  } catch(e) { console.error(e); }
})();
})();
